import { get } from 'lodash';
import { connect } from 'react-redux';

import { actions } from 'Data/actions';
import { EMPTY_OBJ } from 'Services/constants/empty';
import meetingConstants from 'Services/constants/meetings';
import PatientLogin from './component';

export default connect((state) => ({
  isFetching: get(state, ['Meeting', 'isFetchingMeetingState']),
  attendeeGuid: get(state, ['Location', 'payload', 'attendee_guid']),
  meetingIsActive: get(state, ['Meeting', 'meetingState'], EMPTY_OBJ).status === meetingConstants.statuses.active,
}), (dispatch) => ({
  openDeviceSettingsModal: () => dispatch(actions.modalOpen({
    id: 'deviceSettings',
  })),
  locationPatientMeeting: (consultGuid, attendeeGuid) => dispatch({
    type: 'PATIENT_MEETING',
    payload: {
      consult_guid: consultGuid,
      attendee_guid: attendeeGuid,
    },
  }),
  meetingJoin: (patientName, consultGuid, attendeeGuid) =>
    dispatch(actions.meetingJoin(patientName, consultGuid, attendeeGuid)),
}))(PatientLogin);
